import { LoginContainer } from "components/Login";
import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import backgroundImage from "assets/images/Faith-2000x1340-c-center.jpg";
import { OTPForm } from "components/OTP";

/**
 * OTP
 */
const OTP = () => {
  const intl = useIntl();
  const selectedBanner = banners[0];

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "OTP.Title" })}</title>
      </Helmet>
      <LoginContainer banner={selectedBanner}>
        <OTPForm />
      </LoginContainer>
    </>
  );
};

const banners = [
  {
    title: "Built to support careers, not gigs.",
    label: "Faith Adekogbe",
    description: "Frontend Developer",
    cover: `url(${backgroundImage})`,
  },
];

export default OTP;
